import { createContext } from 'react'

const OfferCardFacilitiesFallbackContext = createContext(false)

export default OfferCardFacilitiesFallbackContext
